import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { Box, Divider, Grid, Progress, Typography } from 'web-library';
import ContactDetails from '../../../../components/ContactDetails';
import PersonalDetails from '../../../../components/PersonalDetails';
import SelectedSubjectReview from '../../../../components/SelectedSubjectsReview';
import { ResitSummarySubjectInfoItem } from '../../../../api/candidate/resit/model';
import {
  GroupResitRegistrationResponse,
  useGetGroupResitReview,
} from '../../../../api-refactored/group-resit-registration/useGetGroupResitReview';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) => ({
  pageContent: {
    padding: theme.spacing(4),
  },
  formContainer: {
    width: '100%',
  },
}));

interface CandidateIndividualReviewProps {
  selectedCandidate: number;
  candidateTableRows: {
    name: any;
    id: any;
  }[];
  resitUuid: string;
  state: any;
}

const normalizeCandidateId = (candidateId: unknown) =>
  String(candidateId || '')
    .trim()
    .toUpperCase();

const CandidateIndividualReview = ({
  selectedCandidate,
  candidateTableRows,
  resitUuid,
  state,
}: CandidateIndividualReviewProps) => {
  const { classes } = useStyles();

  const { data: groupResitReviews, isLoading, error } = useGetGroupResitReview({
    uuid: resitUuid,
  });

  const selectedCandidateId = candidateTableRows[selectedCandidate]?.id;
  const groupResitReview = groupResitReviews?.find(
    (review) => normalizeCandidateId(review.nricFin) === normalizeCandidateId(selectedCandidateId)
  );

  if (isLoading) {
    return <Progress color="secondary" />;
  }

  if (error || !groupResitReview) {
    return (
      <Typography variant="body2" color="error">
        Unable to retrieve the candidate&apos;s re-sit registration details. Please try again.
      </Typography>
    );
  }

  const pointer = state.resitCandidates?.[candidateTableRows[selectedCandidate]?.id] || {};

  return (
    <Box key={selectedCandidate.toString()} className={classes.pageContent}>
      <Grid container justify="space-around" spacing={2}>
        <Grid md={12}>
          <PersonalDetails
            statutoryName={groupResitReview.statutoryName}
            hanyuPinyinName={groupResitReview.hanyuPinyinName}
            nricFin={groupResitReview.nricFin}
            nationality={groupResitReview.nationality}
            citizenship={groupResitReview.citizenship}
            schoolName={groupResitReview.schoolName}
          />
        </Grid>
        <Divider />
        <Grid md={12}>
          <ContactDetails
            contactDetails={{
              ...pointer,
            }}
            editable={false}
          />
        </Grid>
        <Divider />
        <Grid md={12}>
          <SelectedSubjectReview
            showGST
            examLevel={groupResitReview.subject.examLevel}
            examYear={groupResitReview.examYear}
            candidateSubjects={[
              {
                nameDescription: groupResitReview.subject.subject,
                code: groupResitReview.subject.subjectCode,
                examSeriesDescription: groupResitReview.subject.examSeries,
                levelDescription: groupResitReview.subject.subjectLevel,
                gst: groupResitReview.subject.gst,
                examFee: groupResitReview.subject.examFees,
              } as ResitSummarySubjectInfoItem,
            ]}
            gstRegNo={groupResitReview.gstNo}
            totalExamFee={groupResitReview.subject.examFees}
            totalFee={groupResitReview.subject.totalSubjectFees}
            totalGst={groupResitReview.subject.gst}
            totalPayable={groupResitReview.subject.totalPayable}
            gstAbsorbed={groupResitReview.subject.gstAbsorbed}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CandidateIndividualReview;
